module.exports = __webpack_public_path__ + "static/00044.97bbf8ac.jpg";